import { render, staticRenderFns } from "./timebox_status_badge.vue.js?vue&type=template&id=29ebd15d!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./timebox_status_badge.vue?vue&type=template&id=29ebd15d"
import script from "./timebox_status_badge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./timebox_status_badge.vue?vue&type=script&lang=js"
export * from "./timebox_status_badge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./timebox_status_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ebd15d')) {
      api.createRecord('29ebd15d', component.options)
    } else {
      api.reload('29ebd15d', component.options)
    }
    module.hot.accept("./timebox_status_badge.vue.js?vue&type=template&id=29ebd15d!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./timebox_status_badge.vue?vue&type=template&id=29ebd15d", function () {
      api.rerender('29ebd15d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/iterations/components/timebox_status_badge.vue"
export default component.exports